module.exports = __webpack_public_path__ + "img/sellerstatus5.1bacf8cc.png";